import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import PhoneSvg from 'pubweb-smokey/dist/images/svg/iconography-16x16/phone.svg';
import LocationLineSvg from 'pubweb-smokey/dist/images/svg/iconography-16x16/location-line.svg';

import {
  formatPhoneNumberFromNumber,
  formatStringToDisplayCase,
  formatDealerName,
  formatDistance,
} from 'pubweb-smokey/dist/utils/formatters';

import { RetailerDealerInfoStyles } from './RetailerDealerInfo.styled';

const RetailerDealerInfo = ({
  name,
  distance,
  phone,
  address1,
  city,
  state,
  postalCode,
  slug,
  inStock = false,
  onContainerClick = null,
}) => {
  return (
    <RetailerDealerInfoStyles
      className={`store-container`}
      onClick={onContainerClick}
    >
      <hr className="separator-upper" />
      <div className="dealer-info-inside">
        {inStock && (
          <div className="stock-indicator label">
            <div className="in-stock-dot">&nbsp;</div> In Stock
          </div>
        )}

        <h5 className="distance standard">
          Distance: {formatDistance(distance)} miles
        </h5>
        <div className="dealer-name">
          <Link href={`/locations/${slug}/`} className="h5">
            {formatDealerName(name)}
          </Link>
        </div>
        <div className="store-info">
          <p className="store-phone">
            <span>
              <PhoneSvg />
            </span>
            <p>{formatPhoneNumberFromNumber(phone)}</p>
            <a href={`tel:${formatPhoneNumberFromNumber(phone)}`}>
              {formatPhoneNumberFromNumber(phone)}
            </a>
          </p>
          <p className="store-address address-line-one">
            <span>
              <LocationLineSvg />
            </span>
            {formatStringToDisplayCase(address1)}
          </p>
          <p className="store-address address-line-two">
            {formatStringToDisplayCase(city)}, {state} {postalCode}
          </p>
          <p className="view-homes">
            <Link href={`/locations/${slug}/`}>view homes</Link>
          </p>
        </div>
      </div>
      <hr className="separator-lower" />
    </RetailerDealerInfoStyles>
  );
};

RetailerDealerInfo.propTypes = {
  address1: PropTypes.any,
  city: PropTypes.any,
  distance: PropTypes.any,
  inStock: PropTypes.bool,
  name: PropTypes.any,
  onContainerClick: PropTypes.any,
  phone: PropTypes.any,
  postalCode: PropTypes.any,
  slug: PropTypes.any,
  state: PropTypes.any,
};

RetailerDealerInfoStyles.propTypes = {
  dealerNumber: PropTypes.string,
  name: PropTypes.string,
  distance: PropTypes.number,
  phone: PropTypes.string,
  address1: PropTypes.string,
  address2: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  postalCode: PropTypes.string,
  slug: PropTypes.string,
  inStock: PropTypes.bool,
  onContainerClick: PropTypes.func,
};

export default RetailerDealerInfo;
